/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SystemRoleBit } from '@gh/builder-shared-data';
import { AppRouter, createDialogRoute, FormState, FormStateBuilder } from '@gh/common-shared';
import { DEFAULT_COUNTRY_CODE } from '@gh/config';
import {
  DialogInput,
  NotificationService,
  responsiveDialogOverlayPaneClass,
  WaitingService,
} from '@gh/core-ui';
import { isEmpty } from 'lodash';
import { BuilderUserContext } from '../../../user';
import { CommunicationsBusinessService } from '../../resources/communications-business.service';
import { SmsService } from '../../../services/sms.service';

@Component({
  selector: 'gh-sms-view-dialog',
  template: require('./sms-view-dialog.component.html'),
  styles: [require('./sms-view-dialog.component.scss')],
 })
export class SmsViewDialogComponent implements OnInit, DialogInput<any> {
  input: any;
  form: FormState<any>;

  constructor(private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder,
              private businessService: CommunicationsBusinessService,
              private router: AppRouter,
              private userContext: BuilderUserContext,
              private waitingService: WaitingService,
              private notificationService: NotificationService,
              private smsService: SmsService,
    ) {

  }

  ngOnInit(): void {
    const sms = this.input.sms;

    const cellPhone = sms && sms.cellPhone;
    if (sms && !sms.isMarkedAsRead) {
      // tslint:disable-next-line:no-non-null-assertion
      this.businessService.markAsRead({
        entityIds: [sms.communicationId],
        isMarkAsRead: true,
      }).pipe(
        this.waitingService.operator(),
      ).subscribe((res) => {
        this.smsService.sendName();
      });
    }
    // add country code only if it does not exist in the phone
    const countryPrefix = `+${DEFAULT_COUNTRY_CODE}`;

    this.form = this.formStateBuilder.buildPlain({
     value: {
       ...sms,
       // tslint:disable-next-line:max-line-length no-non-null-assertion
       cellPhone: `${isEmpty(cellPhone) || !cellPhone!.startsWith(countryPrefix) ? countryPrefix : ''}${cellPhone || ''}`,
       reply: '',
     },
     children: {
       cellPhone: {enabled: false},
       message: {enabled: false},
       reply: void 0,
     },
   });
  }

  get canReply(): boolean {
    return this.userContext.hasSystemRole(SystemRoleBit.Franchisee)
      || this.userContext.hasSystemRole(SystemRoleBit.JobAdmin);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onOk(): void {
    this.dialogRef.close();
  }

  onReply(): void {
    this.businessService.onReply({
      cellPhone: this.input.sms.cellPhone,
      message: this.form.value.reply,
      communicationType: 'OUTGOING_SMS',
      contactId: this.input.sms.contactId,
    }).subscribe((res) => {
      this.dialogRef.close(true);
    },           this.notificationService.processAll);
  }

  navigateToContact(): void {
    this.dialogRef.close({ redirect: true });
  }
}

export const smsViewDialogRoute = createDialogRoute({
  component: SmsViewDialogComponent,
  config: {
    disableClose: true,
    panelClass: responsiveDialogOverlayPaneClass(),
    width: '430px',
  },
});
